<script>
export default {
    props: {
        name: String,
        min: Number,
        max: Number,
        unit: String,
        value: {}
    },
    methods: {
        input(val) {
            this.$emit('input', val)
        }
    }
}
</script>

<template>
    <div class="BgSlider" >
        <p class="name" >{{name}}</p>
        <el-slider :value="value" @input="input" :min="min" :max="max" :show-tooltip="false" :step="1" show-input input-size="mini" ></el-slider>
        <p class="limit" >{{unit}}（{{min}}-{{max}}）</p>
    </div>
</template>

<style lang="scss" scoped>
.BgSlider {
    display: flex;
    align-items: center;
    height: 32px;
    margin-bottom: 10px;
    .name {
        width: 90px;
    }
    .el-slider {
        flex-grow: 1;
        padding: 0 10px;
    }
    .limit {
        color: #7F7F7F;
        margin-left: 7px;
        width: 171px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/bgConfig/BgSlider.vue